import { FC, useCallback } from 'react'

import { MonthlyAnalytics } from 'commons/types/DTO/bank/alerts/monthlyAnalytics'
import { TableDataQa } from 'commons/types/enums'
import { Layer } from 'ui/components/Layer'
import { PageSection, PageSectionFace } from 'ui/components/Page'
import { Table } from 'ui/components/Table'
import { useAlertsContext } from '~bank-alerts/context'

import { columns } from './columns'
import { Filter } from './components'

export const MonthlyAnalyticsTable: FC = () => {
  const { data, isTableLoading, onPageChange } = useAlertsContext()

  const {
    form: { monthlyAnalyticsPage, monthlyAnalyticsSize },
    showMonthlyAnalytics,
    showMonthlyAnalyticsTotalCount
  } = data

  const handlePageChange = useCallback(
    (page: number, size: number) => {
      onPageChange(page, size, 'monthlyAnalytics')
    },
    [onPageChange]
  )

  return (
    <PageSection face={PageSectionFace.PRIMARY} title="Monthly Analytics" anchor="mr">
      <Layer rounded shadowed stretch>
        <Filter />
        <Table<MonthlyAnalytics>
          dataQa={TableDataQa.BP_ALERTS_MONTHLY_ANALYTICS}
          columns={columns()}
          dataSource={showMonthlyAnalytics.map((el) => ({
            item: el
          }))}
          loading={isTableLoading('monthlyAnalytics')}
          pagination={{
            page: monthlyAnalyticsPage || 1,
            size: monthlyAnalyticsSize || 10,
            onChange: handlePageChange,
            total: showMonthlyAnalyticsTotalCount
          }}
        />
      </Layer>
    </PageSection>
  )
}
